import { Component, Input } from '@angular/core';
import { BadgeClasses, ProductInfo } from 'src/app/models/product';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.sass']
})
export class ProductListComponent {
  @Input() public products: ProductInfo[] = null;
  @Input() public isClientLink: boolean = false;
  @Input() public blockTitle: string;
  @Input() public subtitle: string;
  @Input() public linkId: string = 'recently-viewed-';
  @Input() public emptyMessage: string;

  public badgeClasses = BadgeClasses;
  public ENV = environment;

}
